import { themes } from './constants';
import { normalizeTheme } from './utils';

export const defaultLearnScore = themes.reduce((acc, theme) => ({
  ...acc,
  [normalizeTheme(theme)]: 0,
}), {});

export const defaultStats = {
  totalQuizzes: 0,
  flashcardsStudied: 0,
  currentStreak: 0,
  badges: [],
  lastStudyDate: null,
};

export const defaultUserData = {
  stats: defaultStats,
  activity: { daily: {}, monthly: {} },
  dailyFlashcards: {},
  dailySessions: {},
  totalSessionsByTheme: {},
  totalFlashcardsByTheme: {},
  sessionHistory: [],
  learnScore: defaultLearnScore,
  performance: { byTheme: {} },
};